<template>
  <div :class="{ 'dark-theme-splashscreen': darkTheme }">
    <div class="loader" :class="{ fadeout: !isLoading }">
      <a-spin :spinning="true" :class="{ fadeout: !isLoading }">
        <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
      </a-spin>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SplashScreen',
  props: ['isLoading'],
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme
    })
  }
}
</script>

<style scoped lang="scss">
.loader {
  background-color: #fafafa;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  padding-top: 45vh;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}
.fadeout {
  animation: fadeout 1.5s forwards;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
